import React from "react";
import { ArrowRight } from "lucide-react";
import consumerImg from "../../../../assets/images/Landing_Page/consumer_to_opportunity.webp";
import { consumerJourney } from "../data/content";

export default function ConsumerToOpportunity() {
  return (
    <section className="section-py">
      <div className="container text-center">
        <h2 className="section-title">From Consumer to Opportunity</h2>

        <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mt-3">
          {consumerJourney.map((step, i) => (
            <React.Fragment key={step}>
              <span
                style={{
                  color: "var(--blue-500)",
                  fontWeight: 700,
                  fontSize: "0.85rem",
                }}
              >
                {step}
              </span>
              {i < consumerJourney.length - 1 && (
                <ArrowRight size={16} color="var(--blue-300)" />
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="diagram-card mt-4">
          <div className="diagram-image-frame">
            <img src={consumerImg} alt="From Consumer to Opportunity" />
          </div>
        </div>

        <p className="section-subtitle mt-4">
          SELECTEZI is designed to help people discover that they may have
          more than one role in the business ecosystem. A person may begin as
          a customer and later discover a product, skill, resource or
          opportunity that can become a business.
        </p>

        <div className="section-eyebrow mt-3">
          WHERE PEOPLE DISCOVER WHAT THEY CAN BECOME TOMORROW
        </div>
      </div>
    </section>
  );
}
